import Http from "@/api/http";
//import router from "@/router";

const User = {
    namespaced: true,
    state: {
        token: null,
        expired: null,
        userinfo: null,
        stationid: 0
    },
    getters: {
        token(state) {
            return state.token;
        },
        stationid(state) {
            return state.stationid;
        }
    },
    mutations: {
        login(state, data) {
            state.token = data.token;
            state.expired = data.expire_in;
            state.userinfo = data.userinfo;
        },
        logout(state) {
            state.token = null;
            state.expired = null;
            state.userinfo = null;
        },
        setstationid(state, data) {

            state.stationid = data
        }
    },
    actions: {
        login(context, data) {
            Http.get("/userinfo", {
                headers: {
                    Authorization: 'Bearer ' + data.token
                }
            }).then(res => {
                if (res.code == 1) {
                    context.commit("login", Object.assign({}, { userinfo: res.data }, data))

                }
            })

        },
        logout(context) {
            context.commit("logout")
        }
        ,
        setstationid(context, data) {
            context.commit("setstationid", data)
        }
    }
}
export default User;